<main class="c-content">
  <form class="c-content__form" [formGroup]="form" (submit)="prosseguir()">
    <fieldset class="c-content__fieldset">
      <label class="c-content__label">Contrato - Nome cliente *
        <app-select-auto-complete inputClass="c-content__input" [dados]="contratos.registros"
          [filtrar]="filtrarContratos" [exibir]="exibirContrato" [valor]="valorContrato" formControlName="contrato"
          [funcaoDeComparacao]="comparaContrato" required></app-select-auto-complete>
      </label>
      <label class="c-content__label">Site - Endereço *
        <app-select-auto-complete inputClass="c-content__input" [dados]="sites.registros" [filtrar]="filtrarSites"
          [exibir]="exibirSite" [valor]="valorSite" [funcaoDeComparacao]="comparaSite" formControlName="site"
          required></app-select-auto-complete>
      </label>
      <label class="c-content__label">Número de Série/Produtos/Localização *
        <app-select-auto-complete inputClass="c-content__input" [dados]="equipamentos.registros"
          [filtrar]="filtrarEquipamentos" [exibir]="exibirEquipamento" [valor]="valorEquipamento"
          [funcaoDeComparacao]="comparaEquipamento" formControlName="equipamento" required></app-select-auto-complete>
      </label>
      <label for="codDefeito" class="c-content__label">
        Defeito *
        <select required class="c-content__input is-select" required name="codDefeito" formControlName="codDefeito">
          <option *ngFor="let defeito of defeitos" [ngValue]="defeito.codigo">
            {{defeito.nome}}
          </option>
        </select>
      </label>
      <label for="motivo" class="c-content__label u-margin-bottom-2rem">
        Motivo *
        <input class="c-content__input is-input" placeholder="Digite aqui..." name="motivo" formControlName="motivo"
          maxLength="50" />
      </label>
      <label for="obsDefeito" class="c-content__label u-margin-bottom-2rem">
        Observação
        <textarea class="c-content__input is-textarea" placeholder="Digite aqui..." name="obsDefeito"
          formControlName="obsDefeito" maxLength="3000">
          </textarea>
      </label>
      <app-botao-submit class="c-content__submit" [disabled]="form.invalid">Continuar</app-botao-submit>
    </fieldset>
  </form>
</main>